import { render, staticRenderFns } from "./EdsTooltip.vue?vue&type=template&id=502e20bc&"
import script from "./EdsTooltip.vue?vue&type=script&lang=js&"
export * from "./EdsTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports